
import { defineComponent } from "vue";

type Props = Readonly<{
  fetchCategory: () => Promise<void>;
  isSwitchCategoryType: boolean;
}>;

export default defineComponent({
  name: "SwitchCategoryType",
  props: {
    categoryType: {
      type: String,
      required: true,
    },
    handleSwitchCategoryType: {
      type: Function,
      required: true,
    },
    isSwitchCategoryType: {
      type: Boolean,
      required: true,
    },
  },
});
